var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64199 4.99992L9.30866 6.66659H16.667V14.9999H3.33366V4.99992H7.64199ZM8.33366 3.33325H3.33366C2.41699 3.33325 1.67533 4.08325 1.67533 4.99992L1.66699 14.9999C1.66699 15.9166 2.41699 16.6666 3.33366 16.6666H16.667C17.5837 16.6666 18.3337 15.9166 18.3337 14.9999V6.66659C18.3337 5.74992 17.5837 4.99992 16.667 4.99992H10.0003L8.33366 3.33325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.b6f13475af8a12fd818bad1dc8a57280.svg";
export { ForwardRef as ReactComponent };